import clsx from "clsx";
import { useFormContext } from "react-hook-form";

type DateProps = { // The common Part

  callbackYear: (e: any) => void;
  callbackMonth: (e: any) => void;
  callbackDay: (e: any) => void;
  validateDay: (e: any) => any;
  validateYear: (e: any) => any;
  readOnly: boolean;
  methods?: any;
}


export default function DateComponent(props: DateProps) {
  let methods = useFormContext();
  if (methods == null){
    methods = props.methods;
  }

  return (
    <>
      <div className="flex mt-3">
        <div className="flex relative">
          <span>
            <img
              src="assets/error-icon.svg"
              className={clsx(
                methods.formState?.errors?.month ? "" : "hidden",
                "w-4 h-4 absolute top-3.5 max-xxs:ml-[40px] max-sm:ml-[70px] xs:max-md:ml-[80px] md:ml-[110px]"
              )}
              alt="error"
              height={5}
              width={5}
            />
          </span>
          <select
            id="dobMonth"
            {...methods.register("month", {
              required: "Enter your month of birth",
            })}
            defaultValue=""
            style={{pointerEvents: props.readOnly ? "none" : undefined}}
            className={clsx(
              methods.formState?.errors?.month?.message ? "error" : "",
              "date-component mr-4 pt-2.5"
            )}
            onChange={props.callbackMonth}
            disabled={props.readOnly}
          >
            <option hidden value="">
              Month
            </option>
            <option value="01">January</option>
            <option value="02">February</option>
            <option value="03">March</option>
            <option value="04">April</option>
            <option value="05">May</option>
            <option value="06">June</option>
            <option value="07">July</option>
            <option value="08">August</option>
            <option value="09">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
          </select>
        </div>
        <div className="flex relative">
          <span>
            <img
              src="assets/error-icon.svg"
              className={clsx(
                methods.formState?.errors?.day ? "" : "hidden",
                "w-4 h-4 absolute top-3.5 max-xxs:ml-[50px] max-sm:ml-[70px] xs:max-md:ml-[90px] md:ml-[110px]"
              )}
              alt="error"
              height={5}
              width={5}
            />
          </span>
          <input
            placeholder="DD"
            className={clsx(
              methods.formState?.errors?.day?.message ? "error" : "",
              "date-component mr-4"
            )}
            type="text"
            disabled={props.readOnly}
            maxLength={2}
            id="day"
            {...methods.register("day", {
              required: "Enter your date of birth",
              min: {
                value: 1,
                message: "Please enter correct day",
              },
              pattern: {
                value: /^(([0]?[1-9])|([1-2][0-9])|(3[01]))$/,
                message: "Please enter correct day",
              },
              validate: props.validateDay,
            })}
            onChange={props.callbackDay}
          />
        </div>
        <div className="flex relative">
          <span>
            <img
              src="assets/error-icon.svg"
              className={clsx(
                methods.formState?.errors?.year ? "" : "hidden",
                "w-4 h-4 absolute top-3.5 max-xxs:ml-[50px] max-sm:ml-[70px] xs:max-md:ml-[90px] md:ml-[110px]"
              )}
              alt="error"
              height={5}
              width={5}
            />
          </span>
          <input
            placeholder="YYYY"
            className={clsx(
              methods.formState?.errors?.year?.message ? "error" : "",
              "date-component mr-4"
            )}
            type="text"
            disabled={props.readOnly}
            maxLength={4}
            id="year"
            {...methods.register("year", {
              required: "Enter your year of birth",
              min: {
                value: 1900,
                message: "Please enter correct year",
              },
              pattern: {
                value: /^\d+$/,
                message: "Please enter correct year",
              },
              validate: props.validateYear,
            })}
            onChange={props.callbackYear}
          />
        </div>
      </div>

      <div>
        {" "}
        {((methods.formState?.errors?.month?.message ||
          methods.formState?.errors?.day?.message ||
          methods.formState?.errors?.year?.message || methods.formState?.errors?.date2?.message) && methods.formState?.errors?.year?.type != "validate") && (
            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
              Please enter a valid date of birth
            </span>
          )}

      </div>
      <div>
        {methods.formState?.errors?.year?.type === "validate" && (
          <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
            {methods.formState?.errors?.year?.message?.toString()}
          </span>
        )}

      </div>
    </>
  );
}
